module.exports = __webpack_public_path__ + "static/media/iframeBackground.7cae0e0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/organisms/KidsTour/iframeBackground.png
// module id = 927
// module chunks = 0